<div class="badge" [class]="color ? color : BadgeColorsEnum.Default" [class.option]="isOption">
  <div class="content" [style.max-width]="maxWidth">
    <ng-content></ng-content>
  </div>
  <div *ngIf="isOption"
       (click)="removeOption.emit();$event.stopPropagation()"
       class="remove-icon animation-focus-default"
       [ngClass]="{'default': !color || color === BadgeColorsEnum.Default,
       'gray': color === BadgeColorsEnum.Gray,
       'green': color === BadgeColorsEnum.Green,
       'yellow': color === BadgeColorsEnum.Yellow,
       'red': color === BadgeColorsEnum.Red,
       'blue': color === BadgeColorsEnum.Blue,
       'pink': color === BadgeColorsEnum.Pink}"
  ></div>
</div>
